import { render, staticRenderFns } from "./modalIncapacidades.vue?vue&type=template&id=16c1fad0"
import script from "./modalIncapacidades.vue?vue&type=script&lang=js"
export * from "./modalIncapacidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports